import "./App.css";
import About from "./containers/About/About";
import Blog from "./containers/Blogs/Blog";
import Contact from "./containers/Contact/Contact";
import Experience from "./containers/Experience/Experience";
import Footer from "./containers/Footer/Footer";

import { Box } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Header from "./containers/Header/Header";
import about from "./utils/about";
import AboutMe from "./containers/About/AboutMe";
import blogs from "./utils/blog";
import contactContent from "./utils/contact";
import experiences from "./utils/experience";

const theme = createTheme({
  typography: {
    fontFamily: ["Nunito", "sans-serif"].join(","),
    h4: {
      fontSize: "2rem",
      "@media (max-width:600px)": {
        fontSize: "1.5rem",
      },
    },
    body1: {
      fontSize: "1rem",
      "@media (max-width:600px)": {
        fontSize: "0.875rem",
      },
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          padding: "0 24px",
          "@media (max-width:600px)": {
            padding: "0 16px",
          },
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Header />
        <Box
          bgcolor={"whitesmoke"}
          sx={{ pt: { xs: 8, md: 36 }, pb: 12, px: { xs: 2, md: 8 } }}
        >
          <About about={about} />
        </Box>
        <Box bgcolor={"whitesmoke"} sx={{ py: { xs: 8, md: 10 }, px: 0 }}>
          <AboutMe
            title={about.title}
            description={about.description}
            techinalSkillsTitle={about.techinalSkillsTitle}
            skills={about.skill}
          />
        </Box>
        <Box bgcolor={"whitesmoke"} sx={{ py: { xs: 8, md: 12 }, px: 0 }}>
          <Experience experiences={experiences} />
        </Box>
        <Box bgcolor={"whitesmoke"} sx={{ py: { xs: 8, md: 12 }, px: 0 }}>
          <Blog blogs={blogs} />
        </Box>
        <Box bgcolor={"whitesmoke"} sx={{ py: { xs: 8, md: 16 }, px: 0 }}>
          <Contact content={contactContent} />
        </Box>
        <Box bgcolor={"whitesmoke"} sx={{ pt: { xs: 8, md: 8 }, px: 0 }}>
          <Footer />
        </Box>
        {/* <AnimatedGradientBorderTW /> */}
      </div>
    </ThemeProvider>
  );
}

export default App;
